import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { ICreatePaymentMethodRequest, ITogglePaymentMethodRequest } from "./request.types";
import type { TGetPaymentMethodsDataResponse, TGetPaymentMethodsStateResponse } from "./response.types";

class PayoutSettingsController extends Controller {
	public constructor() {
		super({ requestUrl: "models/payment-methods" });
	}

	/**@GET PAYMENT METHODS STATE */
	public async getPaymentMethodsStateAsync({ token }: IRequestConfig) {
		return this.get<TGetPaymentMethodsStateResponse>("base", "/state", { token });
	}

	/**@GET PAYMENT METHODS DATA */
	public async getPaymentMethodsDataAsync({ token }: IRequestConfig) {
		return this.get<TGetPaymentMethodsDataResponse>("base", "", { token });
	}

	/**@POST CREATE PAYMENT METHOD */
	public async createPaymentMethodAsync({ token, paymentMethodId, userPaymentValues }: ICreatePaymentMethodRequest) {
		return this.post<void>("", { paymentMethodId, userPaymentValues }, { token });
	}

	/**@POST TOGGLE PAYMENT METHOD */
	public async togglePaymentMethodAsync({ token, paymentMethodId, active }: ITogglePaymentMethodRequest) {
		return this.post<void>("/toggle", { paymentMethodId, active }, { token });
	}
}

export const payoutSettingsAPI = new PayoutSettingsController();
